import React from 'react';
import styled from 'styled-components';

import { fontSize, colours, spacing } from '../../../theme';
import Button from '../../common/button';
import Modal from '../../common/modal';

const TileContainer = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: ${fontSize.small};
`;

const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  padding: ${spacing.small};
  margin: ${spacing.small};
  width: 15em;
  background-color: ${colours.white};
  border: solid 0.3em ${colours.yellow};
  position: relative;
  text-align: center;
`;

const EmployerLogo = styled.img`
  max-width: 6em;
`;

const EmployerName = styled.h2`
  text-transform: uppercase;
  font-size: ${fontSize.small};
`;

const Criteria = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: ${spacing.tiny};
  margin-bottom: ${spacing.small}
`;

const CriteriaLogo = styled.img`
  width: 3.5em;
  height: 3.5em;
  margin: 0.5em;
  object-fit: contain;
  cursor: pointer;
`;

const ButtonContainer = styled.div`
position: absolute;
bottom: 0;
margin: ${spacing.tiny} 0;
`;

const Tiles = ({ employersRecord, schemesRecord, modalIsOpen, setModalIsOpen }) => {

  const [criteriaName, setCriteriaName] = React.useState(null);

  const handleClick = (e) => {
    if (!modalIsOpen) {
      setModalIsOpen(true);
      setCriteriaName(e.target.alt);
    } else {
      setModalIsOpen(false);
    }
  };

  const checkSchemeTrue = (employerRecord, scheme) => {
    if (employerRecord.fields[scheme.fields.scheme_name] === 'TRUE') {
      return (
        <div>
          <CriteriaLogo
            src={scheme.fields.scheme_logo_url}
            alt={scheme.fields.scheme_name}
            onClick={((e) => handleClick(e))}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div>
    <TileContainer>
      {employersRecord.map(employerRecord => {
        return (
          <Tile>
            <EmployerLogo src={employerRecord.fields.logo_url} />
            <EmployerName>{employerRecord.fields.employer_name}</EmployerName>
            <p>
              {employerRecord.fields.employer_description}
            </p>
            <Criteria>
              {schemesRecord.map((scheme) => {
                return checkSchemeTrue(employerRecord, scheme);
              })}
            </Criteria>
            <ButtonContainer>
              <a href={employerRecord.fields.employer_careers_page}
                target="_blank"
                rel="noopener noreferrer">
                <Button label="See open positions" />
              </a>
            </ButtonContainer>
          </Tile>
        );
      })}
    </TileContainer>
    {!modalIsOpen ? null : <Modal schemesRecord={schemesRecord} criteriaName={criteriaName} modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />}
    </div>
  );
};

export default Tiles;
